import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=5d4e8f76&scoped=true&"
import script from "./Address.vue?vue&type=script&lang=ts&"
export * from "./Address.vue?vue&type=script&lang=ts&"
import style0 from "./Address.vue?vue&type=style&index=0&id=5d4e8f76&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4e8f76",
  null
  
)

export default component.exports